import React, {Component} from 'react';

class Logo extends Component{
    render(){
        var style = {
            align: 'center',
            height: '180px'
          }
        return(
            <img src="/elgc_logo1.png" alt='here comes the logo' style={style} />
        );
    }
}
export default Logo;


// WEBPACK FOOTER //
// ./src/Components/FormInputs/Logo.js